export interface DealerInfoKeyArguments {
  approvalId: string;
}

/**
 * Hierarchical query-key factory for the Dealer Information popup read.
 * Mirrors `applicationStatusKeys` — keyed on approvalId alone, since the BFF
 * endpoint is `/api/v1/workbench/applications/{approvalId}/dealer-info`.
 */
export const dealerInfoKeys = {
  all: ["dealerInfo"] as const,
  details: () => [...dealerInfoKeys.all, "detail"] as const,
  detail: (arguments_: DealerInfoKeyArguments) => [...dealerInfoKeys.details(), arguments_] as const,
};
